var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-title"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('div',{staticClass:"eng"},[_vm._v(" "+_vm._s(_vm.engTitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }